import L from 'leaflet';

/**
 * Custom Leaflet marker icon shared by AddressMapViewer and AddressMapPicker.
 * Styles: src/styles/global/address-map-viewer.less
 * @returns {L.DivIcon}
 */
export const createAddressMapMarkerIcon = ({ hasBackground = true, variant = 'default' } = {}) => {
  const isSelected = variant === 'selected';
  const isWorkplace = variant === 'workplace';
  const isMark = variant === 'mark';

  if (isWorkplace) {
    return L.divIcon({
      className: 'address-map-viewer-marker-wrapper',
      html: `
        <div class="address-map-viewer-marker address-map-viewer-marker--workplace" aria-hidden="true">
          <svg class="address-map-viewer-marker-icon" viewBox="0 0 24 24" width="16" height="16" focusable="false">
            <path fill="currentColor" d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/>
          </svg>
        </div>
      `,
      iconSize: [36, 36],
      iconAnchor: [18, 18],
      popupAnchor: [0, -14],
    });
  }

  const markerClass = [
    'address-map-viewer-marker',
    isSelected ? 'address-map-viewer-marker--selected' : '',
    isMark ? 'address-map-viewer-marker--mark' : '',
  ]
    .filter(Boolean)
    .join(' ');
  const dotClass = [
    'address-map-viewer-marker-dot',
    isSelected ? 'address-map-viewer-marker-dot--selected' : '',
    isMark ? 'address-map-viewer-marker-dot--mark' : '',
  ]
    .filter(Boolean)
    .join(' ');

  if (hasBackground) {
    return L.divIcon({
      className: 'address-map-viewer-marker-wrapper',
      html: `
        <div class="${markerClass}">
          <span class="${dotClass}"></span>
        </div>
      `,
      iconSize: [32, 32],
      iconAnchor: [16, 16],
      popupAnchor: [0, -12],
    });
  }

  return L.divIcon({
    className: 'address-map-viewer-marker-wrapper',
    html: `<div class="address-map-viewer-marker-dot-host"><span class="${dotClass}"></span></div>`,
    iconSize: [32, 32],
    iconAnchor: [16, 16],
    popupAnchor: [0, 0],
  });
};
